document.addEventListener("DOMContentLoaded", function() {
    //BASIC INFO
    const basicInfoEl = document.querySelector(".gtm--basic_info_event");
    if (basicInfoEl) {
        //get necessary dynamic data
        let pageType = basicInfoEl.querySelector(".page_type")?.value;
        let pageTitle = basicInfoEl.querySelector(".page_title")?.value;
        let currentLanguage = basicInfoEl.querySelector(".current_language")?.value;
        let page_id = basicInfoEl.querySelector(".page_id")?.value;

        if (pageType === 'index') {
            pageType = 'home'
        } else if (pageType === 'page') {
            pageType = 'other'
        }

        //clear dataLayer
        window.dataLayer =  window.dataLayer || [];
        window.dataLayer.push({
            event: "basic_info",
            page_type: pageType,
            page_title: pageTitle,
            current_language: currentLanguage,
            ...(page_id && {page_id: page_id })
        });
    }

    //USER LOGIN/LOGOUT
    const customerCheck = document.querySelector(".gtm--user_data");
    if (customerCheck) {
        //get necessary dynamic data
        let userType = customerCheck.querySelector(".user_type").value;
        let customerId = customerCheck.querySelector(".customer_id")?.value;
        let customerEmail = customerCheck.querySelector(".customer_email")?.value;
        let ordersCount = customerCheck.querySelector(".orders_count")?.value;
        let totalSpent = customerCheck.querySelector(".total_spent")?.value;
        let lastOrderDate = customerCheck.querySelector(".last_order_date")?.value;

        //clear dataLayer
        window.dataLayer =  window.dataLayer || [];
        window.dataLayer.push({
            event: "user_data",
            user_type: userType,
            ...(customerId && { customer_id: customerId }),
            ...(customerEmail && { customer_email: customerEmail }),
            ...(ordersCount && { orders_count: ordersCount }),
            ...(totalSpent && { total_spent: totalSpent }),
            ...(lastOrderDate && { last_order_date: lastOrderDate })
        });
    }
});

fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const cartData = [];

        const productFetchPromises = cart.items.map((item, index) => {
            return fetch(`/products/${item.handle}.js`)
                .then(response => response.json())
                .then(product => {
                   let cartDataObj = {
                        item_name: item.product_title,
                        item_id: String(item.id),
                        item_variant: item.variant_title ? item.variant_title : '',
                        item_brand: item.vendor,
                        index: index + 1,
                        price: item.price / 100,
                        discount: parseFloat(((product.variants.find(variant => variant.id === item.id)?.compare_at_price || item.price) / 100 - item.price / 100).toFixed(2)),
                        quantity: item.quantity,
                    };

                    cartData.push(cartDataObj);
                });
        });

        Promise.all(productFetchPromises)
            .then(() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: "cart_data",
                  cart_data_value: cart.total_price / 100,
                  cart_data_currency: cart.currency,
                  cart_data_items: cartData
              })
            })
            .catch(error => console.error('Error fetching product data:', error));
    })
    .catch(error => console.error('Error fetching cart:', error));
